import { getBinaryMarketOptions } from '../market-card/binary-options';
import type { EventDetailMarket } from '@/libs/sdk/api';

type EventSectionCardVariantInput = {
  markets: EventDetailMarket[];
  isHero: boolean;
};

export const getEventSectionCardVariant = ({
  markets,
  isHero,
}: EventSectionCardVariantInput): 'heroChart' | 'compactMarket' | 'event' => {
  if (markets.length !== 1) return 'event';

  const [{ options = [] }] = markets;
  const normalizedOptions = options.map(option => ({
    tokenName: option.name,
    tokenAddress: option.address,
  }));
  const { yes, no } = getBinaryMarketOptions(normalizedOptions);

  if (!yes || !no) return 'event';

  return isHero ? 'heroChart' : 'compactMarket';
};
